import { User } from '../models/user';
import { Injectable } from "@angular/core";

@Injectable()
export class GlobalConstants {
    public static appName: string = "santosh";
    public user: User;
}